import api from "../helpers/axios";

class FacilityAboutService {

    async getGlobalAbout() {
        try {
            const response = await api.get(`/facility_about/global`);
            return response?.data;
        } catch (error) {
            console.error("Error fetching global About default:", error);
            throw error;
        }
    }

    async updateGlobalAbout(payload) {
        try {
            const response = await api.patch(`/facility_about/global`, payload);
            return response?.data;
        } catch (error) {
            console.error("Error updating global About default:", error);
            throw error;
        }
    }

    async getFacilityAboutRaw(facilityNumber) {
        try {
            const response = await api.get(`/facility_about/${facilityNumber}/raw`);
            return response?.data;
        } catch (error) {
            console.error(`Error fetching About config for facility ${facilityNumber}:`, error);
            throw error;
        }
    }

    async createFacilityAbout(facilityAboutData) {
        try {
            const response = await api.post('/facility_about/', facilityAboutData);
            return response?.data;
        } catch (error) {
            console.error("Error creating facility About config:", error);
            throw error;
        }
    }

    async updateFacilityAbout(facilityNumber, payload) {
        try {
            const response = await api.patch(`/facility_about/${facilityNumber}`, payload);
            return response?.data;
        } catch (error) {
            console.error(`Error updating About config for facility ${facilityNumber}:`, error);
            throw error;
        }
    }
}

export default new FacilityAboutService();
